var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashcan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28544 2.14124H5.14258C5.22115 2.14124 5.28544 2.07696 5.28544 1.99839V2.14124H10.714V1.99839C10.714 2.07696 10.7783 2.14124 10.8569 2.14124H10.714V3.42696H11.9997V1.99839C11.9997 1.36803 11.4872 0.85553 10.8569 0.85553H5.14258C4.51222 0.85553 3.99972 1.36803 3.99972 1.99839V3.42696H5.28544V2.14124ZM14.2854 3.42696H1.71401C1.39794 3.42696 1.14258 3.68232 1.14258 3.99839V4.56982C1.14258 4.64839 1.20686 4.71267 1.28544 4.71267H2.36401L2.80508 14.052C2.83365 14.6609 3.33722 15.1412 3.94615 15.1412H12.0533C12.664 15.1412 13.1658 14.6627 13.1944 14.052L13.6354 4.71267H14.714C14.7926 4.71267 14.8569 4.64839 14.8569 4.56982V3.99839C14.8569 3.68232 14.6015 3.42696 14.2854 3.42696ZM11.9158 13.8555H4.08365L3.65151 4.71267H12.3479L11.9158 13.8555Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcan);
export default __webpack_public_path__ + "static/media/trashcan.5b35e3d1e4641d0c66f3d24aed3fc307.svg";
export { ForwardRef as ReactComponent };